import { MAPPING_EDIT_CERTIFICATION, DELETE_CERTIFICATION } from '../actionTypes/actionTypes'

export function editCertification(currentCertification) {
    return { type: MAPPING_EDIT_CERTIFICATION, currentCertification }
}

export function deleteCertification(deleteCertificationId) {
    return { type: DELETE_CERTIFICATION, data: { deleteCertificationId } }
}